import { Input, Button, Avatar, Dropdown, Menu } from "antd";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  SendOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useState } from "react";
import CommentItem from "./CommentItem";
import { useAuth } from "contexts/AuthContext";

const { TextArea } = Input;

const CommentsSection = ({
  comments,
  loading = false,
  onAdd,
  onEdit,
  onDelete,
  user
}) => {
  const { firstName, lastName } = user || {};
  const fullName = `${firstName} ${lastName}`;

  // const [allComments, setAllComments] = useState([...comments]);
  const [newComment, setNewComment] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState("");

  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    await onAdd(newComment);
    setNewComment("");
  };

  const handleDelete = async (id) => {
    await onDelete(id);
  };

  const handleEditSave = async (id) => {
    await onEdit(id, editingText);
    setEditingId(null);
    setEditingText("");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {/* Comment Form */}
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "flex-start",
        }}
      >
        <Avatar>
          {firstName?.charAt(0).toUpperCase()}
          {lastName?.charAt(0).toUpperCase()}
        </Avatar>
        <div style={{ flex: 1 }}>
          <TextArea
            rows={3}
            placeholder="Write a comment..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            onPressEnter={(e) => {
              if (!e.shiftKey) {
                e.preventDefault();
                handleAddComment();
              }
            }}
            style={{
              borderRadius: 8,
              resize: "none",
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 8,
            }}
          >
            <Button
              type="primary"
              icon={<SendOutlined />}
              onClick={handleAddComment}
            >
              Comment
            </Button>
          </div>
        </div>
      </div>

      {/* Comments List */}
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        {comments?.map((comment) => (
          <CommentItem
            key={comment.id}
            comment={comment}
            user={fullName}
            editingId={editingId}
            setEditingId={setEditingId}
            editingText={editingText}
            setEditingText={setEditingText}
            onDelete={handleDelete}
            onSave={handleEditSave}
          />
        ))}
      </div>
    </div>
  );
};

export default CommentsSection;
